import { AlertTriangle, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Alert, AlertDescription } from "@/components/ui/alert";

interface ImpersonationBannerProps {
  targetUserEmail: string;
  onExit: () => void;
}

export const ImpersonationBanner = ({ targetUserEmail, onExit }: ImpersonationBannerProps) => {
  return (
    <Alert className="fixed top-0 left-0 right-0 z-50 rounded-none border-0 border-b-4 border-destructive bg-destructive/90 text-destructive-foreground backdrop-blur-sm">
      <AlertTriangle className="h-5 w-5" />
      <AlertDescription className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <span className="font-bold uppercase tracking-wider">
            Impersonation Mode Active
          </span>
          <span className="text-sm opacity-90">
            Viewing as: {targetUserEmail}
          </span>
        </div>
        <Button
          onClick={onExit}
          variant="secondary"
          size="sm"
          className="gap-2 bg-background text-foreground hover:bg-background/90"
        >
          <LogOut className="h-4 w-4" />
          Exit & Return to Admin
        </Button>
      </AlertDescription>
    </Alert>
  );
};
